import { clsx as o } from "clsx";
import { twMerge as t } from "tailwind-merge";
var p = (...r) => t(o(r));
export {
  p as cn
};

//# sourceMappingURL=utils.js.map